import { usePathname, useRouter, useSearchParams } from 'next/navigation';
import { useCallback } from 'react';

export function useSubmitQueryParameter(paramName: string, resetParams?: string[]) {
  const router = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();

  const createQueryString = useCallback(
    (name: string, value: string) => {
      const params = new URLSearchParams(searchParams.toString());
      params.set(name, value);
      if (resetParams) {
        for (const param of resetParams) {
          params.delete(param);
        }
      }

      return params.toString();
    },
    [resetParams, searchParams]
  );

  const submitSearch = useCallback(
    (searchTerm: string) => {
      if (!searchTerm) {
        return router.push(pathname);
      }
      router.push(`${pathname}?${createQueryString(paramName, searchTerm)}`);
    },
    [router, pathname, createQueryString, paramName]
  );

  return { submitSearch };
}
